import React, { Component, Fragment } from 'react';
import IsLoadingBar from '../isLoading';
import './D365CRM.scss';
import './QuickView.scss';
import './JiraAttachments.scss';
import JiraDetails from './JiraDetails';

function handleMissingData(searchResult) {
  let searchData = {};
  for (let [key, value] of Object.entries(searchResult)) {
    searchData[key] = value.length === undefined ? '' : value;
  }
  return searchData;
}

export default class Jira extends Component {
  constructor(props) {
    super(props);
    this.state = {
      JiraNumber: this.props.JiraNumber,
      JiraData: [],
      isLoading: true,
    };
  }

  componentDidMount() {
    let data = this.props.searchResult;
    if (data !== undefined) {
      try {
        let jiraData = handleMissingData(data);
        this.setState({
          JiraData: jiraData,
          isLoading: false,
        });
      } catch {
        console.log('something went wrong');
      }
    } else {
      console.log('result data missing.');
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.JiraNumber !== this.props.JiraNumber) {
      this.setState({
        JiraNumber: this.props.JiraNumber,
      });
    }
  }

  render() {
    return (
      <div id='D365CRM' className='Quickview-details'>
        {!this.state.isLoading ? (
          <Fragment>
            <JiraDetails JiraDetails={this.state.JiraData} />
          </Fragment>
        ) : (
          <IsLoadingBar />
        )}
      </div>
    );
  }
}
